var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicOnSm = function SvgMicOnSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4S4 1.8 4 4v2c0 2.2 1.8 4 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 7.1c.1-.5-.3-1-.8-1.1s-1.1.3-1.1.8c-.5 3-3 5.2-6 5.2S2.5 9.8 2.1 6.9C2 6.3 1.5 5.9.9 6c-.5.1-.9.6-.8 1.1.5 3.6 3.4 6.3 6.9 6.8V16h2v-2.1c3.5-.4 6.4-3.2 6.9-6.8"
  }))));
};
export default SvgMicOnSm;